module.exports = __webpack_public_path__ + "static/media/download-arrow-icon.df84d8b4.svg";